<template>
  <div class="AboutMe">
    <div id="form-div">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-12">
          <i class="icon icon-profile"></i>
          <label for="org-name">
            {{ $t('aboutMe.communityOrgNameLabel') }}
          </label>
        </div>
        <div class="col-md-12" style="width:90%;">
          <input
              v-model="orgName"
              type="text"
              id="org-name"
              name="orgName"
              @blur="userInfoStore.exitedField"
              @change="userInfoStore.orgNameChanged"
              :disabled="!editMode"
              value
              :placeholder="$t('aboutMe.communityOrgNamePlaceholder')"
          />
        </div>

        <br />
        <br />

        <div class="col-md-12">
          <i class="icon icon-profile"></i>
          <label for="first-name">
            {{ $t('aboutMe.nameLabel') }}
          </label>
        </div>

        <div class="col-md-5">
          <input
              v-model="firstName"
              type="text"
              id="first-name"
              @blur="userInfoStore.exitedField"
              @change="userInfoStore.firstNameChanged"
              value
              :placeholder="$t('aboutMe.firstNamePlaceholder')"
              :disabled="!editMode"
          />
        </div>

        <div class="col-md-6">
          <input
              v-model="lastName"
              type="text"
              id="last-name"
              name="lastName"
              @blur="userInfoStore.exitedField"
              @change="userInfoStore.lastNameChanged"
              value
              :placeholder="$t('aboutMe.lastNamePlaceholder')"
              :disabled="!editMode"
          />
        </div>
      </div>

      <div class="row justify-content-center align-items-center">
        <div class="col-md-12">
          <i class="icon icon-mail"></i>
          <label for="email">
            {{ $t('aboutMe.emailLabel') }}
          </label>
        </div>
        <div class="col-md-11">
          <input
              v-model="email"
              type="email"
              name="email"
              id="email"
              value
              :placeholder="$t('aboutMe.emailPlaceholder')"
              @blur="userInfoStore.exitedField"
              @change="userInfoStore.emailChanged"
              :disabled="!editMode"
          />
        </div>
      </div>

      <div class="row justify-content-center align-items-center">
        <div class="col-md-12">
          <i class="icon icon-mail"></i>
          <label for="jobTitle">
            {{ $t('aboutMe.jobTitleLabel') }}
          </label>
        </div>
        <div class="col-md-11">
          <input
              v-model="jobTitle"
              type="text"
              name="jobTitle"
              id="jobTitle"
              value
              :placeholder="$t('aboutMe.jobTitlePlaceholder')"
              @blur="userInfoStore.exitedField"
              @change="userInfoStore.jobTitleChanged"
              :disabled="!editMode"
          />
        </div>
      </div>

      <div class="row justify-content-center align-items-center">
        <div class="col-md-12">
          <i class="icon icon-new-construction"></i>
          <label>
            {{ $t('aboutMe.locationLabel') }}
          </label>
        </div>

        <div class="col-md-7">
          <input
              v-model="city"
              type="text"
              id="city"
              name="city"
              value
              :placeholder="$t('aboutMe.cityPlaceholder')"
              style="margin-right:10px; margin-top:10px"
              @blur="userInfoStore.exitedField"
              @change="userInfoStore.cityChanged"
              :disabled="!editMode"
          />
        </div>

        <div class="col-md-4">
          <input
              v-model="state"
              type="text"
              id="state"
              name="state"
              value
              :placeholder="$t('aboutMe.statePlaceholder')"
              style="margin-right:10px; margin-top:10px"
              @blur="userInfoStore.exitedField"
              @change="userInfoStore.stateChanged"
              :disabled="!editMode"
          />
        </div>

        <div class="col-md-11">
          <input
              v-model="country"
              type="text"
              id="country"
              name="country"
              value
              :placeholder="$t('profile.countryPlaceholder')"
              style="margin-right:10px; margin-top:10px"
              @blur="userInfoStore.exitedField"
              @change="userInfoStore.countryChanged"
              :disabled="!editMode"
          />
        </div>
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_AboutMe.js" lang="js"></script>
<style src="./_AboutMe.less" lang="less" scoped></style>
